import {Component, inject, OnInit, ViewChild, ViewContainerRef, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from "rxjs";
import {ModalRef} from "../../services/modal.service";
import {ContainerDirective} from "../../directives/container.directive";

import {ModalClosedEventTypes} from "../../enums/modal.event";
import {IconComponent} from "../icon/icon.component";
import {ComponentType} from "@angular/cdk/portal";
import {BadgeComponent} from "../badge/badge.component";
import {CdkTrapFocus} from "@angular/cdk/a11y";

@Component({
    selector: 'app-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    imports: [
    ContainerDirective,
    IconComponent,
    BadgeComponent,
    CdkTrapFocus
],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements OnInit {
  modal = inject<ModalRef<unknown>>(ModalRef);

  @ViewChild(ContainerDirective, {static: true}) container!: ContainerDirective;

  public isClosing: boolean = false;

  public ngOnInit(): void {
    const component: ComponentType<unknown> = this.modal.getComponent();

    const viewContainerRef: ViewContainerRef = this.container.viewContainerRef;
    viewContainerRef.clear();
    viewContainerRef.createComponent(component);

    const sub: Subscription = this.modal.subject.subscribe(() => {
      this.isClosing = true;
      sub.unsubscribe();
    });
  }

  public close(closedEventType: ModalClosedEventTypes = ModalClosedEventTypes.Closed): void {
    this.modal.close(null, closedEventType);
  }
}
